import { PinForDays } from '@admin/engagement/incentives/configureIncentive/types'
import { getSendToFromTenantMemberAndTeams } from '@shared/utils/getSendToFromTenantMemberAndTeams'
import { AwardTypeFormData } from './useConfigureAwardTypeForm'

export const getName = (formData: AwardTypeFormData) => formData.name

export const getDescription = (formData: AwardTypeFormData) => formData.description

export const getPoints = (formData: AwardTypeFormData, canConfigurePoints: boolean) =>
  Number.isInteger(formData.points) && canConfigurePoints ? formData.points : 0

export const getSenders = (formData: AwardTypeFormData) =>
  getSendToFromTenantMemberAndTeams(formData.senders)

export const getPointsLocked = (formData: AwardTypeFormData, canConfigurePoints: boolean) =>
  Number(formData.points) === 0 || formData.nomination || !canConfigurePoints
    ? true
    : formData.pointsLocked

export const getBudgetItemId = (formData: AwardTypeFormData, canConfigurePoints: boolean) => {
  // No need for points bank if no points configured
  if (Number(formData.points) === 0) return null
  // No need for points bank if points disabled
  if (!canConfigurePoints) return null
  // Respect user selection
  return formData.budgetItemId || null
}

export const getMediaObjectId = (_formData: AwardTypeFormData, mediaObjectId: string | null) =>
  mediaObjectId

export const getArchived = (formData: AwardTypeFormData, isNomination: boolean) =>
  isNomination ? false : !formData.archived

export const getNomination = (formData: AwardTypeFormData) => formData.nomination

export const getNominationStartAt = (formData: AwardTypeFormData, isNomination: boolean) => {
  if (isNomination && 'dateTimeRange' in formData) return formData.dateTimeRange[0]
  return null
}

export const getNominationEndAt = (formData: AwardTypeFormData, isNomination: boolean) => {
  if (isNomination && 'dateTimeRange' in formData) return formData.dateTimeRange[1]
  return null
}

export const getNotify = (formData: AwardTypeFormData) =>
  'notify' in formData ? formData.notify : false

export const getPinForDays = (formData: AwardTypeFormData, isNomination: boolean) => {
  if (isNomination && 'pinForDays' in formData)
    return formData.pinForDays === PinForDays.NEVER ? null : Number(formData.pinForDays)
  return null
}

export const getMaxNominations = (formData: AwardTypeFormData) =>
  'maxNominations' in formData ? formData.maxNominations : null

export const getTenantWideNominators = (formData: AwardTypeFormData, isNomination: boolean) => {
  if (isNomination && 'tenantWideNominators' in formData)
    return formData.tenantWideNominators === 'true'
  return true
}

export const getTenantWideCandidates = (formData: AwardTypeFormData, isNomination: boolean) => {
  if (isNomination && 'tenantWideCandidates' in formData)
    return formData.tenantWideCandidates === 'true'
  return true
}

export const getCandidates = (formData: AwardTypeFormData, isNomination: boolean) => {
  if (!isNomination) return []
  if ('tenantWideCandidates' in formData && formData.tenantWideCandidates === 'true') return []
  return 'candidates' in formData ? formData.candidates.map(team => team.id) : []
}

export const getNominators = (formData: AwardTypeFormData, isNomination: boolean) => {
  if (!isNomination) return []
  if ('tenantWideNominators' in formData && formData.tenantWideNominators === 'true') return []
  return 'nominators' in formData ? formData.nominators.map(team => team.id) : []
}

export const getQuestions = (formData: AwardTypeFormData, isNomination: boolean) => {
  if (!isNomination || !('questions' in formData)) return undefined
  return formData.questions
}
